import React from 'react'
import PropTypes from 'prop-types'
import { Popover } from 'antd'

const ChecPopover = ({
  title,
  content,
  children,
  placement,
  trigger,
  arrowPointAtCenter,
}) => (
  <Popover
    title={title}
    content={content}
    placement={placement}
    trigger={trigger}
    arrowPointAtCenter={arrowPointAtCenter}
  >
    {children}
  </Popover>
)

ChecPopover.defaultProps = {
  placement: 'top',
  trigger: 'hover',
  arrowPointAtCenter: true,
}

ChecPopover.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.object,
    PropTypes.array,
  ]),
  placement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),
  trigger: PropTypes.oneOf(['hover', 'click']),
  arrowPointAtCenter: PropTypes.bool,
}

export default ChecPopover
